import React, { Component } from "react";
import NavMenu from "../../navmenu/NavMenu";
import ProjectHeader from "./ProjectHeader";
import ProjectImage from "./ProjectImage";
import bigImage from "../../../assets/images/jaels-creations-desktop-header.jpg";
import "../../../styles/pages/projects/Project.css";
import mobile1 from "../../../assets/images/jaels-creations-mobile-1.png";
import mobile2 from "../../../assets/images/jaels-creations-mobile-2.png";
import gif from "../../../assets/images/jaels-creations-gif.gif";
import ProjectConclusion from "./ProjectConclusion";
import Footer from "../../footer/Footer";
import onScrollHandler from "../../../utilities/onScrollHandler";
import NextPrompt from "../../nextprompt/NextPrompt";

export default class JaelsCreations extends Component {
  componentDidMount() {
    this.onScrollHandler = new onScrollHandler();
  }
  render() {
    return (
      <div className="JaelsCreations page-wrapper">
        <NavMenu />
        <ProjectHeader
          title="JAELS CREATIONS"
          year="2018"
          contributions={["Web Design", "Website Development", "Copywriting"]}
          projectLink={"#"}
          description={
            <div>
              Jaels’ Creations is a clothing alteration store in Canby, Oregon.
              She was receiving an onslaught of phone calls, all pertaining to
              the same few questions.
              <br />
              <br />
              She needed a website to help inform her customers and establish an
              online presence - While doing so in a clean, inviting way.
            </div>
          }
        />
        <ProjectImage
          projectName={"Jaels Creations"}
          layout={"big-image"}
          image={bigImage}
          backgroundColor={"#FF9C46"}
        />
        <div className="gutters">
          <div className="project-text g-sub-text on-scroll-anim">
            The site is developed in Wordpress, and we set up a very simple
            system for her to customize both the FAQ section, and the pricing
            section.
            <br />
            <br />
            The pricing section was a bit of a design challenge. She gave us a
            massive list of her services, and we had to implement it on the site
            in a user-friendly, well-presented way.
          </div>
        </div>
        <ProjectImage
          projectName={"Jaels Creations"}
          layout={"gif-showcase"}
          mobileImages={[mobile1, mobile2]}
          gif={gif}
          backgroundColor={"#FF9C46"}
        />
        <ProjectConclusion
          text={
            <div>
              This was one of our first projects ever, and turned into one of
              our favorite. Since publishing the site, they have actually
              received more phone calls than ever, and had to get help handling
              all of the new business.
              <br />
              <br />
              Alesa at Jael’s Creations gave us a shot when no one else would,
              and this project became the groundwork for our growth as a
              company.
            </div>
          }
        />
        <div className="project-testimonial gutters on-scroll-anim">
          <div className="quote g-sub-text">
            “Gage did excellent work building a website for my business. It’s
            exactly what I asked for and then more than I asked. Derek is
            personable and made the experience so easy. I had put off doing this
            for years and now I’m so glad to have found Callgage.”
          </div>
          <div className="name g-sub-text">- Alesa</div>
        </div>

        <NextPrompt />
        <Footer page={"jaels"} />
      </div>
    );
  }
}
